module.exports = __webpack_public_path__ + "static/media/equisym.0b6ae657.png";